import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust according to your Firebase setup
import './styles/ManageStatDom.css';
import Header from '../components/Header';
import NavbarAdmin from '../components/NavbarAdmin';

const ManageJobConsultant = () => {
  const [consultants, setConsultants] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    titre: '',
    lien: ''
  });

  useEffect(() => {
    const fetchConsultants = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'job_consultant'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setConsultants(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchConsultants();
  }, []);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, 'job_consultant', editId);
      await updateDoc(docRef, {
        ...editData,
        // No need to parse values as numbers since they are strings
      });
      alert("Document updated successfully!");
      setEditId(null);
      setEditData({
        titre: '',
        lien: ''
      });
      // Refetch data to update the table
      const querySnapshot = await getDocs(collection(db, 'job_consultant'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setConsultants(data);
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer cet élément ?");
    if (confirmDelete) {
    try {
      await deleteDoc(doc(db, 'job_consultant', id));
      alert("Document deleted successfully!");
      // Refetch data to update the table
      const querySnapshot = await getDocs(collection(db, 'job_consultant'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setConsultants(data);
    } catch (error) {
      console.error("Error deleting document: ", error);
    }}
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#cc6699',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px'
  };
  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const formStyle = {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    maxWidth: '600px',
    margin: '0 auto',
  };

  return (
    <div>
      <NavbarAdmin />
        <div className="manage-statistics">
          <h2 style={headingStyle}>Gérer les Recrutements Consultants</h2>
          <table>
            <thead>
              <tr>
                <th>Titre</th>
                <th>Lien Drive</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {consultants.map(consultant => (
                <tr key={consultant.id}>
                  <td>{consultant.titre}</td>
                  <td>{consultant.lien}</td>
                  <td>
                    <button
                      className="modifier"
                      onClick={() => {
                        setEditId(consultant.id);
                        setEditData({
                          titre: consultant.titre,
                          lien: consultant.lien
                        });
                      }}
                    >
                      Modifier
                    </button>
                    &nbsp;&nbsp;
                    <button
                      className="supprimer"
                      onClick={() => handleDelete(consultant.id)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {editId && (
            <form onSubmit={handleEditSubmit} style={formStyle}>
              <h3 style={{ color: '#6699CC' }}>Modifier le Recrutement Consultant</h3>
              <label>
                Titre:
                <input
                  type="text"
                  name="titre"
                  value={editData.titre}
                  onChange={handleEditChange}
                  required
                  style={inputStyle}
                />
              </label>
              <br />
              <label>
                Lien Drive:
                <input
                  type="text"
                  name="lien"
                  value={editData.lien}
                  onChange={handleEditChange}
                  required
                  style={inputStyle}
                />
              </label>
              <br />
              <button type="submit" style={buttonStyle}>Mettre à jour</button>
            </form>
          )}
        </div>
      </div>

  );
};

export default ManageJobConsultant;
